import React, { useEffect, useRef, useState } from "react"
import { graphql, Link } from "gatsby"
import styled from 'styled-components'
import { gsap, TweenLite, Power3 } from "gsap"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "../styles/styles.scss"
import LoadInScreen from "../components/LoadIn"
gsap.registerPlugin(TweenLite);

export default function IndexPage({data, location 
  // this prop will be injected by the GraphQL query below.
}) {
  const { allMarkdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter } = allMarkdownRemark.edges[0].node;
  const {Objects, LoadIn} = frontmatter;
  const {title, subtitle, logo, logoAlt} =  LoadIn;  
  const collectionRef = useRef("null")
  const [showLoad, setShowLoad] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('visited') === "true") {
      setShowLoad(false)
    } else {
      setShowLoad(true)
    }
    const targets = collectionRef.current.children;
    const delayTime = () => localStorage.getItem('visited') === "true" ? 0 : 10;
    TweenLite.set(targets, {opacity: 0});
    TweenLite.staggerTo(targets, 3, {opacity: 1, ease:Power3.easeOut, delay: delayTime()}, .25);
  },[showLoad])
 
  return (
    <Layout >
      <SEO title="Home" />
      <div className="collection-container" >
      { showLoad === true ?
        <LoadInScreen location={location} title={title} subtitle={subtitle} logo={logo} logoAlt={logoAlt}/>    
        : null
      }
        
        <div className="collection" ref={collectionRef}>
          {Objects.map( object=>{
            const {name, URL, image, imageAlt} = object;
            const BackgroundImage = styled.div`
              background-image: url(${image});
            `
            return(
              <Link to={URL}>
                <p className="visually-hidden">{name}</p>
                <BackgroundImage className="bk-img" aria-hidden="true"></BackgroundImage>
                <p className="visually-hidden">{imageAlt}</p>
              </Link>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query HomePageQuery {
    allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "collection"}}}) {
      edges {
        node {
          frontmatter {
            LoadIn {
              title
              subtitle
              logo 
              logoAlt
            }
            Objects {
              name
              URL
              image 
              imageAlt
            }
          }
        }
      }
    }
  }
`;
